import gql from 'graphql-tag';

export const ALL_FUNDS_QUERY = gql`
  {
    allMutualFunds {
      name: shortName
      iClass
      ticker
      trpCode
      cusip
      inceptionDate
      tackedReturnFundInceptionDate
      openToNewInvestors
      openToSubsequentInvestments
      morningStarRatings {
        asOfDate
        morningStarCategoryName
        morningStarOverallRating
        morningStarOverallQuantity
      }
      moneyMarket

      riskLevel
      riskLevelName

      assetClassName

      selectFund

      price {
        asOfDate
        price
        priceChange
      }
      twelveMonthLowPrice {
        price
      }
      twelveMonthHighPrice {
        price
      }
      mutualFundManagers {
        managerName
        managedFundSinceDate
        joinedFirmDate
      }
      standardPerformanceReturns {
        quarterlyAnnualReturns {
          fundPerformance {
            asOfDate
            oneYearReturn
            fiveYearReturn
            tenYearReturn
            sinceInceptionReturn
            sinceInceptionReturnTacked
          }
        }
      }

      sevenDayAnnualizedDividendYieldCompound
      sevenDayYieldSimple
      unsubsidizedSevenDayYieldCompound
      unsubsidizedSevenDayYieldSimple
      sevenDayYieldSimpleAsOfDate

      grossExpenseRatio

      netAssets
      netAssetsAsOfDate

      assetAllocationGroupedRankings {
        name
        percentTotalNetAssets
        asOfDate
      }
      fundDescription
    }
  }
`;

// TODO [2021-02-17]: all mock funds should have a trpCode
export const ALL_FUNDS_MOCK = [
  {
    request: {
      query: ALL_FUNDS_QUERY
    },
    result: {
      data: {
        allMutualFunds: [
          {
            name: 'Financial Services Fund',
            iClass: false,
            moneyMarket: false,
            openToNewInvestors: true,
            ticker: 'PRISX',
            inceptionDate: '1996-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 6.03,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '1996-09-30T04:00:00Z',
            grossExpenseRatio: 0.95,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Floating Rate Fund',
            iClass: false,
            moneyMarket: false,
            openToNewInvestors: true,
            ticker: 'PRFRX',
            inceptionDate: '2011-07-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.04,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.81,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Fl Intermediate Tax-Free Bond Fund',
            iClass: false,
            moneyMarket: false,
            openToNewInvestors: true,
            ticker: 'FLTFX',
            inceptionDate: '1993-03-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.92,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2006-04-10T04:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Equity Index 500 Fund - I Class',
            iClass: true,
            moneyMarket: false,
            openToNewInvestors: true,
            ticker: 'PRUIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.17,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Equity Index 500 Fund',
            iClass: false,
            moneyMarket: false,
            openToNewInvestors: true,
            ticker: 'PREIX',
            inceptionDate: '1990-03-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.27,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Stock Fund - I Class',
            iClass: true,
            moneyMarket: false,
            openToNewInvestors: true,
            ticker: 'PRZIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.09,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'European Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRESX',
            inceptionDate: '1990-02-28T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 4,
              morningStarOverallQuantity: 91
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.95,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Discovery Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRIJX',
            inceptionDate: '2015-09-14T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 5.06,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRMSX',
            inceptionDate: '1995-03-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.24,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Local Currency Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRELX',
            inceptionDate: '2011-05-26T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.73,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.1,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Em Mkts Local Currency Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TEIMX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.06,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.24,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Corporate Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRECX',
            inceptionDate: '2012-05-24T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.89,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.19,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PREMX',
            inceptionDate: '1994-12-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.81,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.93,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Equity Income Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'REIPX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.64,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Equity Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRFDX',
            inceptionDate: '1985-10-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.66,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Europe Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TREMX',
            inceptionDate: '2000-08-31T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.76,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Em Mkts Corporate Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TECIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.18,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.36,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Emerging Markets Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRXIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.13,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.86,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Developing Technologies Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRDTX',
            inceptionDate: '2000-08-31T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.68,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'QM U.S. Small-Cap Growth Equity Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRDSX',
            inceptionDate: '1997-06-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.82,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Diversified Mid-Cap Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRDMX',
            inceptionDate: '2003-12-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.87,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Dividend Growth Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PDGIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.79,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Dividend Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRDGX',
            inceptionDate: '1992-12-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.64,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Dynamic Credit Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'RPELX',
            inceptionDate: '2019-01-10T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.52,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Dynamic Credit Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPIDX',
            inceptionDate: '2019-01-10T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.33,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'California Tax-Free Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TCFEX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.86,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Credit Opportunities Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRCPX',
            inceptionDate: '2014-04-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.74,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.89,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. Equity Research Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRCOX',
            inceptionDate: '1994-11-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.7,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Cap App & Income Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TCFIX',
            inceptionDate: null,
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'California Tax-Free Money Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TCBXX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.73,
            sevenDayYieldSimple: 0.73,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Corporate Income Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TICCX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.3,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.49,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Corporate Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRPIX',
            trpCode: 'CIF',
            inceptionDate: '1995-10-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.09,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.62,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Capital Appreciation & Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TCAPX',
            inceptionDate: null,
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'California Tax-Free Money Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PCTXX',
            inceptionDate: '1986-09-15T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.51,
            sevenDayYieldSimple: 0.51,
            unsubsidizedSevenDayYieldCompound: -0.38,
            unsubsidizedSevenDayYieldSimple: -0.47,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.78,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Capital Appreciation Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRAIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.73,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Capital Appreciation Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRWCX',
            inceptionDate: '1986-06-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.7,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'California Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRXCX',
            inceptionDate: '1986-09-15T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.65,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.5,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Bond Fund (USD Hedged) - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TNBMX',
            inceptionDate: '2017-09-12T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.83,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Blue Chip Growth Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TBCIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.63,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Blue Chip Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRBCX',
            trpCode: 'BCG',
            inceptionDate: '1993-06-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.71,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Balanced Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPBAX',
            inceptionDate: '1939-12-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.68,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Balanced Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'RBAIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.72,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Asia Opportunities Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRAOX',
            inceptionDate: '2014-05-21T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 2.29,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'T. Rowe Price Stable Value Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'SVF-E',
            inceptionDate: '1988-09-12T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Institutional',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 2.03,
            sevenDayYieldSimple: 2.01,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Africa & Middle East Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRAMX',
            trpCode: 'AME',
            inceptionDate: '2007-09-04T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.47,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New York Tax-Free Money Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRNXX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.8,
            sevenDayYieldSimple: 0.8,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New York Tax-Free Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRYIX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.76,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Extended Equity Market Index Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PEXMX',
            inceptionDate: '1998-01-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.35,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Free Income Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TFILX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Small-Cap Value Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRVIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.83,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Virginia Tax-Free Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TFBVX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.61,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Value Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRVLX',
            inceptionDate: '1994-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.81,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Value Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.66,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Virginia Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRVAX',
            inceptionDate: '1991-04-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.42,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.47,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. Treasury Money Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRTXX',
            inceptionDate: '1982-06-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 1.27,
            sevenDayYieldSimple: 1.26,
            unsubsidizedSevenDayYieldCompound: 0.0,
            unsubsidizedSevenDayYieldSimple: 0.0,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.44,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. Treasury Long-Term Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRULX',
            inceptionDate: '1989-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.8,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.51,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. Treasury Intermediate Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRTIX',
            inceptionDate: '1989-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.44,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.51,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. High Yield Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TUHYX',
            inceptionDate: '2017-05-19T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 4.94,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. High Yield Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TUHIX',
            inceptionDate: '2013-04-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.29,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. Bond Enhanced Index Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PBDIX',
            inceptionDate: '2000-11-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.56,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.3,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Ultra Short-Term Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRSTX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.22,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Efficient Equity Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TEEFX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2020 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TTURX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.75,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2060 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRTFX',
            inceptionDate: '2014-06-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 16.35,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2055 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRFFX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 3.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2050 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRFOX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 2.81,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2045 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPTFX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.76,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2040 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRHRX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.42,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2035 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPGRX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.26,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2030 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRWX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.02,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2025 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRVX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.98,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2020 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRUX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.86,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2015 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRTX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.83,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2010 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRROX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.26,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2005 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRARX',
            inceptionDate: '2013-08-20T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.97,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2060 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TTOIX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 15.74,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2055 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPPX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 3.09,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Total Equity Market Index Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'POMIX',
            inceptionDate: '1998-01-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.3,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2050 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TOORX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 2.33,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Efficient Equity Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PREFX',
            inceptionDate: '2000-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.86,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2045 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRFWX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.48,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2040 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRXRX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.18,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Free Intermediate Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PTIBX',
            inceptionDate: '1992-11-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.8,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2006-04-10T04:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2035 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TPGPX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.04,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2030 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TWRRX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.86,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Free Short-Intermediate Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRFSX',
            inceptionDate: '1983-12-23T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.45,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.49,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Free Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRTAX',
            inceptionDate: '1976-10-26T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.8,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.52,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Free High Yield Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRFHX',
            inceptionDate: '1985-03-01T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.27,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Exempt Money Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PTEXX',
            inceptionDate: '1981-04-08T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.65,
            sevenDayYieldSimple: 0.65,
            unsubsidizedSevenDayYieldCompound: -0.35,
            unsubsidizedSevenDayYieldSimple: -0.43,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.51,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2025 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRVVX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.83,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Efficient Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PTEGX',
            inceptionDate: '1999-07-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.25,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Efficient Balanced Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRTEX',
            inceptionDate: '1997-06-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.24,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2015 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TTRTX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.77,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2010 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TORFX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.15,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Target 2005 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TFRRX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.85,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Limited Duration Inflation Focused Bd Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRBFX',
            inceptionDate: '2006-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.73,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.51,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Science & Technology Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSCX',
            inceptionDate: '1987-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.84,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Short-Term Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRWBX',
            inceptionDate: '1984-03-02T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.17,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.52,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Small-Cap Stock Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'OTIIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.78,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPSIX',
            inceptionDate: '1990-06-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.84,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSGX',
            inceptionDate: '1990-06-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.79,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum International Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PSILX',
            inceptionDate: '1996-12-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.94,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Science & Technology Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TSNIX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.66,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Multi-Sector Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSNX',
            inceptionDate: '2008-12-15T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.31,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.82,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Summit Municipal Intermediate Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSMX',
            inceptionDate: '1993-10-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.19,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.5,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Summit Municipal Money Market Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRSXX',
            inceptionDate: '1993-10-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.73,
            sevenDayYieldSimple: 0.72,
            unsubsidizedSevenDayYieldCompound: -0.3,
            unsubsidizedSevenDayYieldSimple: -0.36,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.45,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Summit Municipal Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRINX',
            inceptionDate: '1993-10-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.5,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.5,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Summit GNMA Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSUX',
            inceptionDate: '1993-10-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.52,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2013-09-30T04:00:00Z',
            grossExpenseRatio: 0.6,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Small-Cap Value Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSVX',
            inceptionDate: '1988-06-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.92,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Small-Cap Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'OTCFX',
            inceptionDate: '1956-06-01T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.9,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Cash Reserves Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TSCXX',
            inceptionDate: '1993-10-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 1.33,
            sevenDayYieldSimple: 1.32,
            unsubsidizedSevenDayYieldCompound: -0.25,
            unsubsidizedSevenDayYieldSimple: -0.29,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.45,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Short-Term Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TBSIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.34,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.41,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Ultra Short-Term Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRBUX',
            inceptionDate: '2012-12-03T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.03,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.45,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Real Estate Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TIRRX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.85,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement Balanced I Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPTX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.15,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.5,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2060 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRLX',
            inceptionDate: '2014-06-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.75,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2055 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRNX',
            inceptionDate: '2006-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.75,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2050 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRMX',
            inceptionDate: '2006-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.75,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2045 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRKX',
            inceptionDate: '2005-05-31T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.75,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2005 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRFX',
            inceptionDate: '2004-02-27T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.58,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2035 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRJX',
            inceptionDate: '2004-02-27T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.74,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2025 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRHX',
            inceptionDate: '2004-02-27T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2015 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRGX',
            inceptionDate: '2004-02-27T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.62,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement Balanced Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRIX',
            inceptionDate: '2002-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.08,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.56,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2040 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRDX',
            inceptionDate: '2002-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.75,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2030 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRCX',
            inceptionDate: '2002-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.72,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2020 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRBX',
            inceptionDate: '2002-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.66,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2010 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRRAX',
            inceptionDate: '2002-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.58,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2060 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPLX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.15,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2055 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPNX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.87,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2050 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPMX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Real Assets Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRIKX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.92,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2045 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPKX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.65,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2040 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPDX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.63,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2035 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPJX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.61,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement Income 2020 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRLAX',
            inceptionDate: '2017-05-25T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2030 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPCX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.58,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2025 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPHX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.55,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2020 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRBRX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.52,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Real Estate Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRREX',
            inceptionDate: '1997-10-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.76,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2015 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRFGX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.5,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2010 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPAX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.51,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Retirement 2005 Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRPFX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.78,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Real Assets Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRAFX',
            inceptionDate: '2010-07-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.83,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'QM U.S. Value Equity Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TQVIX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.71,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'QM U.S. Small & Mid-Cap Core Equity Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TQSMX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.1,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'QM U.S. Small & Mid-Cap Core Eq Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TQSIX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.86,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'QM U.S. Value Equity Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TQMVX',
            inceptionDate: '2016-02-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.95,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'QM U.S. Small-Cap Growth Equity Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TQAIX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.66,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Conservative Allocation Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRSIX',
            inceptionDate: '1994-07-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.72,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Moderate Growth Allocation Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRSGX',
            inceptionDate: '1994-07-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.89,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Moderate Allocation Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRPBX',
            inceptionDate: '1994-07-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.84,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Government Money Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRRXX',
            inceptionDate: '1976-01-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 1.28,
            sevenDayYieldSimple: 1.27,
            unsubsidizedSevenDayYieldCompound: -0.31,
            unsubsidizedSevenDayYieldSimple: -0.37,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.48,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Prime Reserve Fund - Plus Class',
            iClass: false,
            openToNewInvestors: true,
            ticker: '',
            inceptionDate: '1998-11-01T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 1.21,
            sevenDayYieldSimple: 1.2,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2002-11-24T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Conservative Alloc Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PPIPX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.63,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Moderate Growth Alloc Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TGIPX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.76,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Spectrum Moderate Alloc Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TPPAX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.7,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mfb Test 77 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: '77XXX',
            inceptionDate: '1976-01-01T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mfb Test 76 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: '76XXX',
            inceptionDate: '1986-09-10T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mfb Test 170 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: '170XX',
            inceptionDate: '2008-01-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Overseas Stock Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TROIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.71,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Overseas Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TROSX',
            inceptionDate: '2006-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.84,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mfb Test 144 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: '144XX',
            inceptionDate: '2014-06-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.01,
            sevenDayYieldSimple: 0.01,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2011-10-19T04:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mfb Test 137 Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: '137XX',
            inceptionDate: '2002-05-31T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New York Tax-Free Money Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'NYTXX',
            inceptionDate: '1986-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.58,
            sevenDayYieldSimple: 0.58,
            unsubsidizedSevenDayYieldCompound: -0.38,
            unsubsidizedSevenDayYieldSimple: -0.48,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.76,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New York Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRNYX',
            inceptionDate: '1986-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.58,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.51,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Asia Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PNSIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.82,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Jersey Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'NJTFX',
            inceptionDate: '1991-04-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.52,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.52,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Income Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRXEX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.87,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.46,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRCIX',
            inceptionDate: '1973-08-31T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.64,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.6,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Horizons Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRJIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.67,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Horizons Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRNHX',
            inceptionDate: '1960-06-03T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.79,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Era Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRNEX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.58,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Era Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRNEX',
            inceptionDate: '1969-01-20T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.67,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Asia Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRASX',
            inceptionDate: '1990-09-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.94,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New America Growth Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PNAIX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.95,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New America Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRWAX',
            inceptionDate: '1985-09-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.79,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mid-Cap Value Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRMIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.68,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Communications & Technology Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TTMIX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Communications & Technology Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRMTX',
            inceptionDate: '1993-10-13T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.79,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Multi-Strategy Total Return Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TMSRX',
            inceptionDate: '2018-02-23T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Maryland Short-Term Tx-Fr Bnd Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRMUX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.3,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Multi-Strategy Total Return Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TMSSX',
            inceptionDate: '2018-02-23T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Tax-Exempt Money Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TERXX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.84,
            sevenDayYieldSimple: 0.84,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Maryland Tax-Free Money Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TWNXX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.87,
            sevenDayYieldSimple: 0.86,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Maryland Short-Term Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRMDX',
            inceptionDate: '1993-01-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.16,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.55,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Maryland Tax-Free Money Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TMDXX',
            inceptionDate: '2001-03-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 200,
            riskLevelName: 'Lower',
            assetClassName: 'Tax-Free Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.78,
            sevenDayYieldSimple: 0.78,
            unsubsidizedSevenDayYieldCompound: -0.39,
            unsubsidizedSevenDayYieldSimple: -0.5,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.6,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Maryland Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'MDXBX',
            inceptionDate: '1987-03-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.54,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.46,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mid-Cap Value Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRMCX',
            inceptionDate: '1996-06-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.8,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mid-Cap Growth Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'RPTIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.64,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Mid-Cap Growth Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPMGX',
            inceptionDate: '1992-06-30T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.77,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Maryland Tax-Free Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TFBIX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.72,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Lmtd Duration Infl Focused Bd Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRLDX',
            inceptionDate: '2015-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 210,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.88,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.36,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'U.S. Large-Cap Core Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRULX',
            inceptionDate: '2009-06-26T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.91,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Latin America Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRLAX',
            inceptionDate: '1993-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 290,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.37,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'New Jersey Tax-Free Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRJIX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.74,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Japan Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRJPX',
            inceptionDate: '1991-12-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.05,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Equity Index Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PIEQX',
            inceptionDate: '2000-11-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.45,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Intermediate Tax-Free High Yield Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRIHX',
            inceptionDate: '2014-07-24T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.61,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.5,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Stock Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRIUX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.67,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRITX',
            inceptionDate: '1980-05-09T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.83,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Inflation Protected Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TIIPX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.72,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.4,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Inflation Protected Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRIPX',
            inceptionDate: '2002-10-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.51,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.58,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Industrials Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPGIX',
            inceptionDate: '2013-10-24T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 2.39,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Value Equity Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TRTIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Intermediate Tax-Free Hy Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TFHAX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.77,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Value Equity Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRIGX',
            inceptionDate: '2012-07-26T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'Institutional',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 3.68,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Value Equity Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRIGX',
            inceptionDate: '1998-12-21T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.84,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Discovery Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TIDDX',
            inceptionDate: '2015-12-17T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.08,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Discovery Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRIDX',
            inceptionDate: '1988-12-30T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.2,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Disciplined Equity Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRCNX',
            inceptionDate: '2014-08-22T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 4.78,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Institutional Cash Reserves Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'ICFXX',
            inceptionDate: '2016-09-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Taxable Money Market',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 1.51,
            sevenDayYieldSimple: 1.5,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.58,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'RPISX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.02,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.82,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Bond Fund (USD Hedged)',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TNIBX',
            inceptionDate: '2017-09-12T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.63,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'International Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPIBX',
            inceptionDate: '1986-09-10T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 240,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.77,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.83,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'High Yield Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRHYX',
            inceptionDate: '1984-12-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.14,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.74,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Health Sciences Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'THISX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Health Sciences Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRHSX',
            inceptionDate: '1995-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.76,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'High Yield Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRHIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.46,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.6,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Dynamic Global Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPIEX',
            inceptionDate: '2015-01-22T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.72,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.69,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Dynamic Global Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'RPEIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 1.92,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 1.89,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Technology Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRGTX',
            inceptionDate: '2000-09-29T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.91,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Growth Stock Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PRUFX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.52,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Growth Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRGFX',
            inceptionDate: '1950-04-11T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.67,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Real Estate Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRGRX',
            inceptionDate: '2008-10-27T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.05,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Infrastructure Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'TRGFX',
            inceptionDate: '2010-01-27T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.68,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Multi-Sector Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'PGMSX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 3.61,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.63,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'GNMA Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRGMX',
            inceptionDate: '1985-11-26T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 220,
            riskLevelName: 'Lower',
            assetClassName: 'Domestic Taxable Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.29,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.59,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRGSX',
            inceptionDate: '1995-12-29T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 280,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.89,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Growth Stock Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPGEX',
            inceptionDate: '2008-10-27T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 270,
            riskLevelName: 'Higher',
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.15,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Growth & Income Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'PRGIX',
            inceptionDate: '1982-12-21T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 260,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 0.67,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global High Income Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPIHX',
            inceptionDate: '2015-01-22T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.34,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 2.18,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Allocation Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TGAFX',
            inceptionDate: '2016-03-23T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Stock',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.25,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global High Income Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'RPOIX',
            inceptionDate: '2015-08-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 0,
            riskLevelName: null,
            assetClassName: 'International/Global Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 5.7,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 2.3,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Georgia Tax-Free Bond Fund - I Class',
            iClass: true,
            openToNewInvestors: true,
            ticker: 'TBGAX',
            inceptionDate: '2017-07-06T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.47,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.0,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Global Allocation Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'RPGAX',
            inceptionDate: '2013-05-28T04:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 250,
            riskLevelName: 'Moderate',
            assetClassName: 'Blended Asset',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 0.0,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            grossExpenseRatio: 1.35,
            __typename: 'GraphQLMutualFund'
          },
          {
            name: 'Georgia Tax-Free Bond Fund',
            iClass: false,
            openToNewInvestors: true,
            ticker: 'GTFBX',
            inceptionDate: '1993-03-31T05:00:00Z',
            morningStarRatings: {
              asOfDate: null,
              morningStarOverallRating: 0,
              morningStarOverallQuantity: 0
            },
            riskLevel: 230,
            riskLevelName: 'Moderate',
            assetClassName: 'Domestic Tax-Free Bond',
            standardPerformanceReturns: {
              quarterlyAnnualReturns: {
                fundPerformance: {
                  asOfDate: '2020-12-31T00:00:00Z',
                  oneYearReturn: 0.33,
                  fiveYearReturn: 0.55,
                  tenYearReturn: 0.28,
                  sinceInceptionReturn: 0.84,
                  sinceInceptionReturnTacked: false,
                  __typename: 'YearlyReturns'
                }
              }
            },
            sevenDayAnnualizedDividendYieldCompound: 0.0,
            sevenDayYieldSimple: 2.26,
            unsubsidizedSevenDayYieldCompound: null,
            unsubsidizedSevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-03-01T05:00:00Z',
            grossExpenseRatio: 0.54,
            __typename: 'GraphQLMutualFund'
          }
        ]
      },
      errors: [],
      dataPresent: true,
      extensions: null
    }
  }
];
